export const initialState = {
    is_loading: true,
    jobs_list: [],
    sort_key: '',
    sort_direction: ''
}